module.exports = __webpack_public_path__ + "static/media/432-hz-music-for-relaxation.24fd6b02.mp3";